export const sleep = (ms: number): Promise<void> => {
	return new Promise((resolve) => setTimeout(resolve, ms))
}

const ua = navigator.userAgent
export const isMobileApp = ua.includes('lynx-activities-app')
